import React from 'react';
import './About.css';

import { Button, Heading } from '../../../components';
import { about, images } from '../../../constants';

import { FaLeaf } from 'react-icons/fa';


const About = () => { 

  return (

    <section className="about">

      {/* About Image */}
      <div className="image">
        <div className="sub-image">
        <img src={images.about1} alt='About-Pic-1' />
        </div>
        <div className="sub-image last">
        <img src={images.about2} alt='About-Pic-2' />
          <div className="experience">
            <span>{about.experience.years}</span> {about.experience.text}
          </div>
        </div>
      </div>

      {/* About Content */}
      <div className="content">

        <Heading title={about.heading} subTitle={about.sub} sideHeading={true} />

        {/* Description */}
        <p>{about.description}</p>

        {/* Key Features */}
        <ul className="about-features">
          {about.points.map((point, index) => (
            <li key={index}>
              <FaLeaf className="icon" /> {/* Leaf icon */}
              <span>{point}</span>
            </li>
          ))}
        </ul>

        <Button link={about.button.link} title={about.button.text} /> {/* About-Us Button */}

      </div>

    </section>
  );
}

export default About;